import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/Addons.js";
import { ambientLight, directionalFillLight, directionalLight } from "./lights";
import { planeSettings } from "./constants";
import { textureDataPromise } from "./textures";
import { setVertexPositionByColor } from "./vertexPositions";

// Добавляем элемент canvas. Для дебага
const canvas = document.createElement("canvas");
canvas.width = 1024;
canvas.height = 1024;
canvas.style.position = "absolute";
// document.body.appendChild(canvas);

// Создаем сцену
const scene = new THREE.Scene();
const fov = 75;

// Создаем камеру и направляем ее строго сверху на плоскость.
const camera = new THREE.PerspectiveCamera(
  fov,
  canvas.width / canvas.height,
  0.1,
  100
);
const cameraDistance =
  planeSettings.side / (2 * Math.tan((fov * Math.PI) / 360)); // Расстояние от камеры до плоскости

camera.position.set(0, cameraDistance, 0);
camera.lookAt(new THREE.Vector3(0, 0, 0));

// Создаем рендерер
const renderer = new THREE.WebGLRenderer({ canvas: canvas });
renderer.setSize(canvas.width, canvas.height);
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;

// Создаем плоскость
const geometry = new THREE.PlaneGeometry(
  planeSettings.side,
  planeSettings.side,
  800,
  800
);
geometry.rotateX(Math.PI / 2);
geometry.rotateY(Math.PI);
const material = new THREE.MeshStandardMaterial({
  side: THREE.DoubleSide,
  shadowSide: THREE.FrontSide,
});
const mesh = new THREE.Mesh(geometry, material);
mesh.castShadow = true;
mesh.receiveShadow = true;
// scene.add(mesh);

const vertices = geometry.attributes.position.array;
const uvs = geometry.attributes.uv.array;
const renderTarget = new THREE.WebGLRenderTarget(2048, 2048);

textureDataPromise.then((context) => {
  // Генерируем рельеф
  for (let i = 0, j = 0; i < vertices.length; i += 3, j += 2) {
    vertices[i + 1] = setVertexPositionByColor(
      { x: uvs[j], y: uvs[j + 1] },
      context
    );
  }
  geometry.attributes.position.needsUpdate = true;
  // Создаем текстуру для запекания
  renderTarget.texture.center.set(0.5, 0.5);
  renderTarget.texture.wrapS = THREE.RepeatWrapping;
  renderTarget.texture.repeat.x = -1;
  // Запекаем сцену в текстуру
  renderer.setRenderTarget(renderTarget);
  renderer.render(scene, camera);
  renderer.setRenderTarget(null); // Возврат к стандартному рендеру
});

// Добавляем в сцену свет. Клонируем тот, что используется в основной сцене.
// TODO: добавить динамический свет
scene.add(ambientLight.clone());
scene.add(directionalFillLight.clone());
scene.add(directionalLight.clone());

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

const tick = () => {
  renderer.render(scene, camera);
  window.requestAnimationFrame(tick);
};
tick();

export { scene as bakedShadowsScene, camera as bakedShadowsCamera };
